module.exports = __webpack_public_path__ + "img/9788994122267.db2f80b2.jpg";